import { NativeEngine } from './engine';
export default NativeEngine;
//# sourceMappingURL=index.js.map